import api from '../../api.js';

export const CheckboxSelector = {
  INPUT: `${api.internals.ns.selector('checkbox-group')} input[type="checkbox"]`
};
